import { useEffect } from "react";

const Impersonate = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const expiresIn = parseInt(params.get("expires_in"), 10) || 3600;

    if (!token) {
      window.location.replace("/login");
      return;
    }

    localStorage.setItem("token", JSON.stringify(token));      // same shape as Login.js
    localStorage.setItem("impersonation", JSON.stringify({
      expires_at: Date.now() + expiresIn * 1000,
    }));

    window.location.replace("/dashboard");                     // full reload → App.js bootstraps user
  }, []);

  return null;
};

export default Impersonate;
